var initialState = null;

export default (state, action) => {
    state = state || initialState;

    switch (action.type) {
        case 'SET_DRAFTS':
            if (action.payload) {
                state = [...action.payload];
            } else {
                state = null;
            }
            break;
    }
    return state;
};
